import { render, staticRenderFns } from "./FugaMigration.vue?vue&type=template&id=5e01693a&scoped=true&"
import script from "./FugaMigration.vue?vue&type=script&lang=js&"
export * from "./FugaMigration.vue?vue&type=script&lang=js&"
import style0 from "./FugaMigration.vue?vue&type=style&index=0&id=5e01693a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01693a",
  null
  
)

export default component.exports